import { Action, Dispatch, Middleware } from "@reduxjs/toolkit";
import { startSessionTimer } from "../services/loginService";

export const resetTimerMiddleware: Middleware<{}, unknown, Dispatch<Action>> = () => (next) => (action: any) => {
    const userInfo = sessionStorage.userInfo && JSON.parse(sessionStorage.userInfo)
    // Pass the action to the next middleware or reducer
    const result = next(action);
    // Check if the action is a fulfilled async thunk (action types ending with '/fulfilled')
    if (action.type.endsWith("/fulfilled")) {
        // Start or reset the session timer after every successful API call
        userInfo && userInfo.user_key.length > 0 && startSessionTimer();
    }
    return result; // Ensure the middleware chain continues by returning the result
};